import { useQuery } from "@apollo/client";
import { gql } from "types";

const GET_EMPLOYEE_DETAILS = gql(/* GraphQL */ `
  query GetEmployeeDetails {
    user {
      findEmployment {
        id
        firstName
        lastName
        nationalId
        nationality
        companyId
      }
    }
  }
`);

export const useEmployeeDetails = () => {
  const { data, loading, error, refetch } = useQuery(GET_EMPLOYEE_DETAILS);

  return {
    employee: data?.user?.findEmployment,
    loading,
    error,
    refetch,
  };
};
